import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import CountrySelect from "lib/components/form/CountrySelect";
import { FormField } from "lib/components/form/FormTypes";
import TextInput from "lib/components/form/TextInput";

import { asTitle } from "utils/Utils";

export type AddressSectionProps = {
	streetName: FormField<string>;
	streetNumber: FormField<string>;
	postalCode: FormField<string>;
	city: FormField<string>;
	country: FormField<string>;
};

export default function AddressSection(
	props: Readonly<AddressSectionProps>
): JSX.Element {
	const { t } = useTranslation();

	return (
		<>
			<Typography variant="h6">{asTitle(t("address"))}</Typography>
			<Grid container direction="column" rowSpacing={2}>
				<Grid item container columnSpacing={2}>
					<Grid item xs={12} sm={6} md={3}>
						<TextInput
							name="streetName"
							label={asTitle(t("streetName"))}
							field={props.streetName}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<TextInput
							name="streetNumber"
							label={asTitle(t("streetNumber"))}
							field={props.streetNumber}
						/>
					</Grid>
				</Grid>
				<Grid item container columnSpacing={2}>
					<Grid item xs={12} sm={6} md={3}>
						<TextInput
							name="postalCode"
							label={asTitle(t("postalCode"))}
							field={props.postalCode}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3}>
						<TextInput
							name="city"
							label={asTitle(t("city"))}
							field={props.city}
						/>
					</Grid>
				</Grid>

				<Grid item container columnSpacing={2}>
					<Grid item xs={12} sm={6} md={3}>
						<CountrySelect field={props.country} />
					</Grid>
				</Grid>
			</Grid>
		</>
	);
}
